var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newReportDateRange(data) {
    var instance = {
        __type: "ReportDateRange:#DecisionsFramework.Design.Flow.CoreSteps.Metro",
        FromDate: new Date('0001-01-01T00:00:00Z'),
        NumberOfDays: 0,
        DateRange: 2 /* DateRangeTypes.Today */,
        RollingDateRangeType: 1 /* RollingDateRangeType.Last */,
        RollingDateRangeTimePeriodType: 1 /* RollingDateRangeTimePeriodType.Days */,
        RollingPeriod: 0
    };
    return __assign(__assign({}, instance), data);
}
export function isReportDateRange(object) {
    return object.__type === "ReportDateRange:#DecisionsFramework.Design.Flow.CoreSteps.Metro";
}
